module.exports = __webpack_public_path__ + "img/manual-icon.d94da9fe.svg";